import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import "typeface-roboto";

import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { store, persistor } from "./redux/store";
import { ConfigProvider } from "antd";

// import "antd/dist/antd.min.css";

if (process.env.NODE_ENV === "production") {
  console.log = () => {
    // console.log
  };
  console.warn = () => {
    // console.warn
  };
  console.error = () => {
    // console.error
  };
}

if (window.top === window.self) {
  ReactDOM.render(
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            inkBarColor: "#E59E06",
            itemSelectedColor: "#E59E06",
            itemHoverColor: "#E59E06",
          },
          Form: {
            labelHeight: "auto",
            verticalLabelPadding: 0,
          },
          Menu: {
            itemMarginBlock: 0,
            itemMarginInline: 0,
            itemSelectedBg: "rgba(18, 50, 116, 1)",
            itemSelectedColor: "rgba(255, 255, 255, 1)",
            itemBorderRadius: 0,
            itemActiveBg: "rgba(18, 50, 116, 1)",
          },
          Radio: {
            buttonSolidCheckedBg: "rgba(18, 50, 116, 1)",
          },
        },
        token: {
          colorBorder: "rgba(217, 217, 217, 1)",
          colorBorderSecondary: "rgba(217, 217, 217, 1)",
        },
      }}
    >
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <HashRouter>
            <App />
          </HashRouter>
        </PersistGate>
      </Provider>
    </ConfigProvider>,
    document.getElementById("root")
  );
}
reportWebVitals();
